import { Component, ContentChild, Directive, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[firstLine]',
  standalone: false,
})
export class SbFirstLineDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[secondLine]',
  standalone: false,
})
export class SbSecondLineDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[thirdLine]',
  standalone: false,
})
export class SbThirdLineDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[fourthLine]',
  standalone: false,
})
export class SbFourthLineDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[fifthLine]',
  standalone: false,
})
export class SbFifthLineDirective {
  @Input() classes: string;
}

@Component({
  selector: 'sb-comp-name-wrapper',
  templateUrl: './sb-name-wrapper.component.html',
  styleUrls: ['./sb-name-wrapper.component.scss'],
  standalone: false,
})
export class SbNameWrapperComponent implements OnInit {
  @ContentChild(SbFirstLineDirective, { static: false }) firstLine?: SbFirstLineDirective;
  @ContentChild(SbSecondLineDirective, { static: false }) secondLine?: SbSecondLineDirective;
  @ContentChild(SbThirdLineDirective, { static: false }) thirdLine?: SbThirdLineDirective;
  @ContentChild(SbFourthLineDirective, { static: false }) fourthLine?: SbFourthLineDirective;
  @ContentChild(SbFifthLineDirective, { static: false }) fifthLine?: SbFifthLineDirective;
  @Input() classes: string;

  constructor() {}

  ngOnInit(): void {}
}
